import React from 'react';
import Tippy from '@tippyjs/react';
import { Tag, Button, TextInput, Plus } from '@opendate-app/setlist';

function TagsCard({
  taggedItems = [],
  availableTags = [],
  currentUser = null,
  showTagPopup = false,
  setShowTagPopup = () => {},
  tagSearchValue = '',
  setTagSearchValue = () => {},
  onToggleTag = () => {},
  onCreateAndAddTag = () => {},
}) {
  const canManage = !!(currentUser && currentUser.can_manage_tagged_items);
  const items = taggedItems.filter((item) => item.tag);

  return (
    <div className="cdp-card cdp-tag-popup-container" style={{ position: 'relative' }}>
      <h2 className="cdp-card-title">Tags</h2>

      <div className="cdp-pill-row">
        {items.map((item) => {
          const { tag } = item;
          const creatorName = item.created_by && item.created_by.name ? item.created_by.name : null;

          return (
            <Tippy key={tag.id} content={creatorName ? `Added by ${creatorName}` : 'Tag'}>
              <span style={{ display: 'inline-flex' }}>
                <Tag
                  size="sm"
                  onDismiss={canManage ? (e) => { e.stopPropagation(); onToggleTag(tag, true, item); } : undefined}
                >
                  {tag.name}
                </Tag>
              </span>
            </Tippy>
          );
        })}

        {items.length === 0 && !canManage && (
          <span style={{ color: 'var(--sl-text-disabled)', fontSize: 12, fontStyle: 'italic' }}>No tags</span>
        )}

        {canManage && (
          <Button
            variant="secondary"
            size="sm"
            icon={Plus}
            onClick={(e) => { e.stopPropagation(); setShowTagPopup(true); }}
          >
            Add Tag
          </Button>
        )}
      </div>

      {showTagPopup && canManage && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1000,
            marginTop: 8,
            backgroundColor: 'var(--sl-bg-primary)',
            border: '1px solid var(--sl-border-primary)',
            borderRadius: 8,
            padding: 16,
            minWidth: 280,
            maxWidth: 360,
            boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.05), 0px 10px 15px -3px rgba(16, 24, 40, 0.1)',
          }}
        >
          <div style={{ fontSize: 14, color: 'var(--sl-text-primary)', marginBottom: 12, fontWeight: 600 }}>
            Manage Tags
          </div>

          <div style={{ marginBottom: 12 }}>
            <TextInput
              size="sm"
              placeholder="Search or create tag…"
              value={tagSearchValue}
              onChange={(e) => setTagSearchValue(e.target.value)}
            />
          </div>

          <div style={{ maxHeight: 250, overflowY: 'auto', display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {availableTags
              .filter((tag) => tag.name.toLowerCase().includes(tagSearchValue.toLowerCase()))
              .map((tag) => {
                const taggedItem = taggedItems.find((item) => item.tag && item.tag.id === tag.id);
                const isActive = !!taggedItem;

                return (
                  <button
                    type="button"
                    key={tag.id}
                    onClick={() => onToggleTag(tag, isActive, taggedItem)}
                    style={{
                      padding: '4px 10px',
                      fontSize: 12,
                      borderRadius: 14,
                      cursor: 'pointer',
                      backgroundColor: isActive ? 'var(--sl-bg-brand-primary)' : 'var(--sl-bg-tertiary)',
                      border: '1px solid var(--sl-border-secondary)',
                      color: isActive ? 'var(--sl-fg-brand)' : 'var(--sl-text-secondary)',
                      fontWeight: 500,
                    }}
                  >
                    {tag.name}
                  </button>
                );
              })}

            {tagSearchValue
              && !availableTags.find((tag) => tag.name.toLowerCase() === tagSearchValue.toLowerCase()) && (
                <button
                  type="button"
                  onClick={() => onCreateAndAddTag(tagSearchValue)}
                  style={{
                    padding: '4px 10px',
                    fontSize: 12,
                    borderRadius: 14,
                    cursor: 'pointer',
                    backgroundColor: 'var(--sl-bg-success-primary)',
                    border: '1px solid var(--sl-border-secondary)',
                    color: 'var(--sl-text-success)',
                    fontWeight: 500,
                  }}
                >
                  + Create &quot;{tagSearchValue}&quot;
                </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default TagsCard;
